
import { Box, Tab, Tabs } from "@mui/material";
import { styled } from "@mui/material/styles";
import React, { useEffect, useState } from "react";
import DemographicTab from "./DemographicTab";
import InfluencerHeader from "./InfluencerHeader";
import Navbar from "./Navbar";
import PostTab from "./PostTab";
import ProfileTab from "./ProfileTab";
import Statistics from "./Statistics";

const InfluencerHome = () => {
  const [userdata, setUserdata] = useState({});
  const [isMobile, setIsMobile] = useState(false);
  const [tabIndex, setTabIndex] = useState(0);

  // Detect mobile screen
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 700);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Fetch user data, send URL to add-link API, then update followers count
  useEffect(() => {
    const id = localStorage.getItem("influencerID");
    if (!id) return;

    // Step 1: Get influencer datass
    fetch(`https://server-side-influencer.onrender.com/influencer/getInfluencer/${id}`)
      .then((res) => res.json())
      .then((data) => {
        const userData = data.data;
        setUserdata(userData);

        // Step 2: Send Instagram URL to add-link APIssds
        if (userData.instagramURL) {
          fetch("https://server-side-influencer.onrender.com/influencer/add-link", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ instaUrl: userData.instagramURL }),
          })
            .then((res) => res.json())
            .then((response) => {
              console.log("Add-link API response:", response);

              const userCount = response?.data?.usersCount;

              if (userCount !== undefined && userCount !== null) {
                console.log("Users Count:", userCount);

                // Step 3: Update followers count
                fetch(`https://server-side-influencer.onrender.com/influencer/updatefollowers/${id}`, {
                  method: "PUT",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify({ followers: userCount }),
                })
                  .then((res) => res.json())
                  .then((updateResponse) => {
                    console.log("Followers count updated:", updateResponse);
                  })
                  .catch((err) => console.error("Error updating followers:", err));
              }
            })
            .catch((err) => console.error("Error calling add-link API:", err));
        }
      })
      .catch((err) => console.error("Error fetching influencer data:", err));
  }, []);

  // Custom styled tab
  const StyledTab = styled(Tab)(({ theme }) => ({
    borderRadius: "25px",
    margin: "0 8px",
    color: "#444",
    fontWeight: 600,
    textTransform: "none",
    backgroundColor: "#f0f0f0",
    "&:hover": {
      backgroundColor: "red",
      color: "white",
    },
    "&.Mui-selected": {
      backgroundColor: "black",
      color: "white",
    },
  }));

  return (
  <div className="flex flex-col h-screen">
        <div className="fixed top-0 left-0 right-0 z-40 bg-white shadow-md">
          <InfluencerHeader page="profile analytics" />
        </div>
  
        <div className="flex flex-1 overflow-y-auto pt-20">
          <div className="text-white fixed top-0 left-0 bottom-0 z-50">
            <Navbar />
          </div>
  

      {/* Main contents */}
      <div className="ml-1 w-full flex flex-col flex-grow">
   

        <div
          className="mr-6 sm:mr-16 md:mr-32 text-right text-sm sm:text-base md:text-xl lg:text-3xl font-medium text-gray-700"
          style={{ marginTop: isMobile ? "94px" : "52px" }}
        >
          👋 Welcome back, {userdata.fullname}
        </div>

        {/* Center Heading */}
        <div className="flex justify-center" style={{ marginTop: isMobile ? "90px" : "40px" }}>
          <h1 className="text-center text-xl sm:text-2xl md:text-3xl font-bold text-gray-800">
            Influencer Profile Analytics
          </h1>
        </div>

        {/* Tabs */}
        <Box sx={{ mt: 5, ml: isMobile ? 0 : 10 }}>
          <Tabs
            value={tabIndex}
            onChange={(e, newValue) => setTabIndex(newValue)}
            TabIndicatorProps={{ style: { display: "none" } }}
            variant="scrollable"
            scrollButtons
            allowScrollButtonsMobile
          >
            <StyledTab label="Profile" />
            <StyledTab label="Post" />
            <StyledTab label="Statistics" />
            <StyledTab label="Demographics" />
          </Tabs>
        </Box>

        {/* Tab Content */}
        <Box sx={{ mt: 4, ml: isMobile ? 2 : 10, mr: isMobile ? 2 : 10 }}>
          {tabIndex === 0 && <ProfileTab     instagramURL={userdata.instagramURL}/>}
          {tabIndex === 1 && <PostTab    instagramURL={userdata.instagramURL} />}
          {tabIndex === 2 && <Statistics instagramURL={userdata.instagramURL} />}

          {tabIndex === 3 && <DemographicTab     instagramURL={userdata.instagramURL} />}
        </Box>
      </div>
    </div>
    </div>
  );
};

export default InfluencerHome;
